import { Component, signal, WritableSignal } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';
import { PermissionService } from '../../../modules/buildings-shared/services/permission.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  imports: [MarkdownComponent, RouterLink],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss',
})
export class PrivacyPolicy {

    permissionService: WritableSignal<PermissionService | undefined> = signal<PermissionService | undefined>(undefined);

    constructor(permissionService: PermissionService) {
        this.permissionService.set(permissionService);
    }
}
